<script>
import NxtTasksApp from '@nextories/vue-tasks/src/components/templates/NxtTasksApp.vue';
import { mapState, mapActions } from 'pinia';
import { defineComponent } from "vue";
import {useSavStore} from "@/store/savStore.ts";
import {useFurnitureStorage} from "@/store/furnitureStorageStore.ts";
import {useUsersStore} from "@nextories/vue-tasks/src/store/usersStore.ts";

export default defineComponent({
  extends: NxtTasksApp,
  mounted() {
    this.rootStore = {
      ...this.rootStore,
      sav: useSavStore,
      furnitureStorage: useFurnitureStorage,
    };
  },
  computed: {
    ...mapState(useSavStore, {
      isLoadedSav: 'isLoaded',
    }),
    ...mapState(useFurnitureStorage, {
      isLoadedFurnitureStorage: 'isLoaded',
    }),
    configViews() {
      return this.defaultConfigViews.concat([{ name: 'sav', location: this.isLocationMovers, init: 'initSavProjects' },
        { name: 'furnitureStorage', location: this.isLocationMovers, init: 'initFurnitureStorage' }]);
    },
    isLocationFurnitureStorage() {
      return (window.location.pathname === '/storage'
        || window.location.pathname.indexOf('/storage?') !== -1);
    },
    isLocationSav() {
      return (window.location.pathname === '/sav'
        || window.location.pathname.indexOf('/sav?') !== -1);
    },
  },
  methods: {
    ...mapActions(useUsersStore, [
      "setAssignedDefaultCurrentUser",
    ]),
    async initFurnitureStorage() {
      await this.initView(useFurnitureStorage(), true, 'furnitureStorage', false, true);
    },
    async initSavProjects() {
      await this.initView(useSavStore(), true, 'sav', false, true);
    },
    async initApp() {
      try {
        await this.getUsers();
        await this.initHistory();
        await this.setInitialNotesFilters();
        this.setAssignedDefaultCurrentUser(this.currentUser);
        if (this.isLocationSav && !this.isLoadedSav) {
          await this.initSavProjects();
        } else if (this.isLocationFurnitureStorage && !this.isLoadedFurnitureStorage) {
          await this.initFurnitureStorage();
        } else if (this.isLocationDiary && !this.isLoadedDiary) {
          await this.initDiary();
        } else if (this.isLocationProjects && !this.isLoadedProjects) {
          await this.initProjects();
        } else if ((this.isLocationHistory || this.isLocationHomeProject || this.isLocationLogin)
          && !this.isLoadedTasks) {
          await this.initTasks(this.isLocationLogin);
        }
      } catch (error) {
        this.redirectToLogin(error);
        console.error(error);
      }
    },
  },
});
</script>

<template>
  <nxt-tasks-easter-egg-rotate v-if="isInit" class="app__wrapper">
    <nxt-tasks-layout :root-store="rootStore" class="app__layout">
      <RouterView/>
    </nxt-tasks-layout>
  </nxt-tasks-easter-egg-rotate>
  <div v-else class="app__wrapper">
    <loader :class="$vClass('loading')"
            :text="$t('base.loading')"
            sizeLoader="--size-small"/>
  </div>
</template>

<style lang="scss">
@use '@nextories/vue-tasks/src/assets/scss/app';
</style>
